import type { SVGProps } from 'react';

interface ThumbUpIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const ThumbUpIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & ThumbUpIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 12 12"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M9.143 12H3.429V4.2l4-4.2.714.75q.1.105.164.285t.064.345v.21L7.743 4.2h3.114q.458 0 .8.36.343.36.343.84v1.2a1.3 1.3 0 0 1-.086.45L10.2 11.28q-.129.3-.429.51t-.628.21M2.286 4.2V12H0V4.2z"
      fill="#44C761"
    />
  </svg>
);
